import {
  ACCORDION_DETAIL_TITLES,
  ACCORDION_DETAIL_TITLES_RESUME,
} from 'document/domain/constants'
import { useEffect, useState } from 'react'
import { useGetLead } from 'lead/application/useGetLead.hook'
import { feedTitleKeys } from 'shared/helpers'
import { findFeedValue } from 'lead/utils'
import { useDocumentsRequiredDetails } from './useDocumentsRequiredDetails.hook'

export const useAccordionDetails = () => {
  const { lead, error, loading, getLead } = useGetLead()
  const [proposalDetail, setProposalDetail] = useState({
    title: '',
    values: null,
    feesDetail: false,
  })
  const {
    getDocumentsRequired,
    documentsRequired,
  } = useDocumentsRequiredDetails()

  const getProposalDetail = () => {
    if (lead?.creditAnalysis == null && lead?.payment == null) {
      setProposalDetail({
        title: ACCORDION_DETAIL_TITLES.REQUESTED,
        resume: ACCORDION_DETAIL_TITLES_RESUME.REQUESTED,
        values: lead?.intendedCredit,
        feesDetail: false,
        amountType: 'amount',
      })
    } else if (lead?.payment == null) {
      setProposalDetail({
        title: ACCORDION_DETAIL_TITLES.RELEASED,
        resume: ACCORDION_DETAIL_TITLES_RESUME.RELEASED,
        values: lead?.creditAnalysis,
        feesDetail: true,
        amountType: 'approvedCreditAmount',
      })
    } else if (lead) {
      setProposalDetail({
        title: ACCORDION_DETAIL_TITLES.PAID,
        resume: ACCORDION_DETAIL_TITLES_RESUME.PAID,
        values: lead?.payment,
        feesDetail: true,
        amountType: 'releasedAmount',
      })
    }
  }
  const feedItems = lead?.feeds

  useEffect(() => {
    getProposalDetail()

    if (findFeedValue(feedTitleKeys.DOCUMENT_REQUIRED, feedItems)) {
      getDocumentsRequired(lead.id)
    }
  }, [lead])

  function handleProposalDetail(idParam) {
    getLead(idParam)
  }

  return {
    handleProposalDetail,
    lead,
    loading,
    error,
    documentsRequired,
    proposalDetail,
  }
}
